import {normalizeTrade, formateTrades} from '@/views/TextCreate/create/config';

export default class textCreateModel {
    constructor({request, config}) {
        this.request = request;
        this.config = config;
    }

    async getTrades() {
        const data = await this.request.fetch('natasha/GET/BasicBxService/getBusinessTree');
        return formateTrades(data);
    }

    rollVideoScript(task, interval, timeout, cancelToken) {
        return this.request.roll(
            'zebra/GET/VideoSynthetiseService/synthetiseStatus',
            {taskIds: task},
            {
                interval,
                timeout,
                until: res => {
                    let {status, errors} = res.taskList[0];
                    status = parseInt(status, 10);
                    // 合成结束
                    if (status === 3) {
                        return true;
                    }
                    // 合成失败
                    if (status !== 2) {
                        throw new Error(errors);
                    }
                    return false;
                },
                cancelToken
            }
        );
    }

    async getVideoScript(url, cancelToken) {
        const {taskIds} = await this.request.fetch('zebra/POST/VideoEditerService/smartAudio', {url});
        const res = await this.rollVideoScript(taskIds, 10e3, 300e3, cancelToken);
        const {ext} = res.taskList[0];
        const transformData = JSON.parse(unescape(ext.replace(/\\u/g, '%u')));
        const scripts = transformData.texts.reduce((pre, cur) => {
            return `${pre}${cur.text}，`;
        }, '');
        return scripts;
    }


    async getPoints(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/salePoints', {
            ...params,
            businessPoint: normalizeTrade(params.businessPoint)
        });
        return data;
    }

    async addTargetUser(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/addTargetUser', params);
        return data;
    }

    async queryTargetUser(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/queryTargetUser', params);
        return data.items;
    }

    async addExample(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/addExample', params);
        return data;
    }

    async submitTitleForm(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/titleGenerate', {
            ...params,
            businessPoint: normalizeTrade(params.businessPoint)
        });
        return data || [];
    }

    async submitTitleFormAsyn(params) {
        params = {
            ...params,
            businessPoint: normalizeTrade(params.businessPoint)
        };
        const data = await this.request.fetch('natasha/POST/TextToolService/syncTitleGenerate', params);
        const res = await this.rollTitleResultList(data.taskId, 1000, 180e3);
        return res.items || [];
    }

    rollTitleResultList(taskId, interval, timeout) {
        return this.request.roll(
            'natasha/POST/TextToolService/queryTaskStatus',
            {taskId},
            {
                interval,
                timeout,
                until: res => {
                    let {status} = res;
                    status = parseInt(status, 10);
                    // 合成结束
                    if (status === 3) {
                        return true;
                    }
                    // 合成失败
                    if (status === 4) {
                        throw new Error('抱歉，本次未能为您生成符合要求的结果，建议您尝试调整重新生成');
                    }
                    return false;
                }
            }
        );
    }

    async submitMouthForm(params) {
        params = {
            ...params,
            businessPoint: normalizeTrade(params.businessPoint)
        };
        const data = await this.request.fetch('natasha/POST/TextToolService/mouthScriptGenerate', params);
        const res = await this.rollMouthResultList(data.taskId, 1000, 180e3);
        return res.items || [];
    }

    rollMouthResultList(taskId, interval, timeout) {
        return this.request.roll(
            'natasha/POST/TextToolService/queryTaskStatus',
            {taskId},
            {
                interval,
                timeout,
                until: res => {
                    let {status} = res;
                    status = parseInt(status, 10);
                    // 合成结束
                    if (status === 3) {
                        return true;
                    }
                    // 合成失败
                    if (status === 4) {
                        throw new Error('抱歉，本次未能为您生成符合要求的文案，建议您尝试调整重新生成');
                    }
                    return false;
                }
            }
        );
    }

    async getHistory(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/historyRecom', params);
        const list = (data.items || []).filter(i => i.records?.length).map(i => {
            return {
                ...i,
                taskId: i.records[0].taskId
            };
        }) || [];
        return {
            ...data,
            list
        };
    }

    async getCollectHistory(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/collectHistory', params);
        const list = (data.items || []).filter(i => i.records?.length).map(i => {
            return {
                ...i,
                taskId: i.records[0].taskId
            };
        }) || [];
        return {
            ...data,
            list
        };
    }

    async queryTaskInputInfo(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/queryTaskInputInfo', params);
        return data;
    }

    async modifyLikeFlag(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/modifyFlag', params);
        return data;
    }

    async collectText(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/collectText', params);
        return data;
    }

    async evaluateText(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/evaluateText', params);
        return data.texts[0];
    }

    async saveText(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/saveToMaterialLibrary', params);
        return data;
    }

    // 口播文案跳转数字人编辑器，获取合成任务列表
    async queryTasks({taskId, pageNum = 1, pageSize = 20}) {
        let predicates = [];
        if (taskId) {
            predicates.push({
                field: 'taskId',
                operator: 'eq',
                value: taskId
            });
        }
        const requestData = {
            predicates,
            page: {
                pageNum,
                pageSize
            }
        };
        const list = await this.request.fetch('zebra/POST/DigitalHumanService/queryTasks', requestData);
        return list.items || [];
    }

    // 口播文案跳转数字人编辑器，获取通用数字人列表
    async getDigicList({humanId, shared, orderBy, pageNum = 1, pageSize = 20}) {
        // 数字人列表拼接查询参数的配置，shared必填
        let predicates = [];
        predicates.push({
            field: 'shared',
            operator: 'eq',
            value: shared
        });
        if (humanId) {
            predicates.push({
                field: 'id',
                operator: 'eq',
                value: humanId
            });
        }
        let requestData = {
            predicates,
            page: {
                pageNum,
                pageSize
            }
        };
        let orderByList = [];
        if (orderBy?.length) {
            orderBy.forEach(item => {
                let itemParts = item.split(',').map(val => val.trim());
                let orderParts = {
                    field: itemParts[0],
                    order: itemParts[1]
                };
                orderByList.push(orderParts);
            });
            requestData = {
                ...requestData,
                orderByList
            };
        }
        const list = await this.request.fetch('zebra/POST/DigitalHumanService/queryDigitalHumans', requestData);
        return list.items || [];
    }

    // 口播文案跳转数字人编辑器，获取模版列表
    async getTemplateList({templateId, pageNum = 1, pageSize = 20}) {
        let predicates = [];
        if (templateId) {
            predicates.push({
                field: 'id',
                operator: 'eq',
                value: templateId
            });
        }
        const requestData = {
            // 查询全部模版，不加查的是lite数据
            searchComplexTPL: true,
            predicates,
            page: {
                pageNum,
                pageSize
            }
        };
        const listData = await this.request.fetch('zebra/POST/DigitalHumanService/queryDigitalHumanTemplates',
            requestData);
        return listData.items || [];
    }



    importUrl(params) {
        return this.request.fetch('natasha/POST/TextToolService/importUrl', params);
    }

    // 任务中心-文案
    // 获取任务列表
    async getTaskList(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/historyRecom', params);
        const list = (data.items || []).filter(i => i.records?.length).map(i => {
            return {
                ...i,
                taskId: i.records[0].taskId
            };
        }) || [];
        return {
            ...data,
            list
        };
    }
    // 删除文案任务
    async deleteTask(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/delTextTaskOrRecord', params);
        return data;
    }
    // 修改任务设置名称
    async updateName(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/updateTextAlias', params);
        return data;
    }

    // 文案库相关
    // 保存到文案库
    async addText(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/saveToMaterialLibrary', params);
        return data;
    }
    // 获取文案库列表
    async getTextList(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/queryMaterial', params);
        return data;
    }

    // 修改文案
    async evaluateTextAssets(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/updateMaterialLibraryText', params);
        return data;

    }

    // 删除、批量删除文案库
    async deleteTextAssets(params) {
        const data = await this.request.fetch('natasha/POST/TextToolService/delMaterialLibrary', params);
        return data;

    }
}
